<template lang="pug">
	.page
		.wrapper
			list-section(
				:title="'Всі продукти компанії FMC'"
				:list="getProductsByCategory(getCategoryBySlug($route.params.category) ? getCategoryBySlug($route.params.category).id : '')"
				:type="'product'"
				:categories="getProductsCatalogs"
				:link="'/products/' + $route.params.category + '/'"
			)
</template>

<script>

  let collectionSlug = 'products';

	import ListSection from '@/components/listSection.vue';
	import AOS from 'aos';
	import {mapState, mapGetters} from 'vuex';

	export default {
		name: collectionSlug,
		metaInfo: function() {
			return {
				title: 'Продукти'
			}
		},
		created() {
			this.check();
		},
		components: {
			'list-section': ListSection,
		},
		methods: {
			check() {
				if ((!this.$route.params.category || !this.getProductsCatalogs.find(item => item.slug === this.$route.params.category)) && this.getProductsCatalogs.length && this[collectionSlug].length) {
					this.$router.push({path: '/products/' + this.getProductsCatalogs[0].slug + '/'})
				}
			}
		},
		computed: {
			...mapState([
				collectionSlug,
				'catalogs',
			]),
			...mapGetters([
				'getProductsCatalogs',
				'getProductsByCategory',
				'getCategoryBySlug'
			])
		},
		mounted() {
			this.$nextTick(() => {
				AOS.init({
					once: true,
					disabled: 'mobile',
					duration: 1000
				});
			})
		},
		watch: {
			catalogs() {
				this.check();
			},
			products() {
				this.check();
			},
			getProductsByCategory() {
				this.check();
			}
		}
	}

</script>

<style lang="scss" scoped>
  >>> .card__category {
		display: none;
	}

  >>> .section__list {
		margin-bottom: 80px;
		margin-top: 20px;
	}

  >>> .categories {
		margin-bottom: 20px;
	}

	@media screen and (min-width: 1201px) {
    >>> .categories {
			margin-bottom: 50px !important;
		}
	}
</style>
